
import { useState, useRef, useEffect } from 'react';

import './AdminQuery.css';
import axios from 'axios';

import { useToast } from '../../CustomeHooks/useToast';

const AdminQuery = () => {

    //console.log("AdminQuery Component triggered");
    const Now = new Date();
    const stringNow = Now.getFullYear() + "-" + 
                      (Now.getMonth() + 1).toString() + "-" +
                      Now.getDate() + " " +
                        Now.getHours() + ":00:00";

    //console.log("Now: ", stringNow);

    const queriesExamples = [
        {
            Id: 1,
            color: "black",
            query: "Select * from Student where Id = ",
        },
        {
            Id: 2,
            color: "black",
            query: "Select * from users where Id = ",
        },
        {
            Id: 3,
            color: "black",
            query: "Select * from Student order by id desc limit 1",  // to get the newest Job
        },
        {
            Id: 4,
            color: "black",
            query: "Select id, jobTitle, postingDate, CompanyUsername from Student where CompanyUsername like '%%' order by id desc",
        },
        {
            // https://github.com/expressjs/express/issues/5244   % = %25
            Id: 5,
            color: "black",
            query: "Select id, jobTitle, postingDate, CompanyUsername from student where jobtitle like '%%' order by id desc",   //    => has beed blocked by cors policy
        },
        // {
        //     Id: 5,
        //     color: "black",
        //     query: "Select Id, Jobtitle, ViewsNb from Student where Id in ()",
        // },
        {
            Id: 6,
            color: "black",
            //query: "Select sum(ViewsNB) as TotalViews from Student",
            query: "Select * from users where email like '%%'",
        },
        {
            Id: 7,
            color: "black",
            query: "Select id, jobtitle, ViewsNB, applicantsids, CompanyUsername from Student where ViewsNb  > 0 order by postingDate desc",
        },
        {
            Id: 8,
            color: "black",
            //query: "Select count(*) from candidates_subscription where Category like '%,,%'",
            query: "Select * from student where applicantsids like '%%'",
            // Select id, username, lastlogingmt  from users order by lastlogingmt desc
        },
        {
            Id: 80,
            color: "black",
            query: "Select id, username,lastlogingmt from users where id <> 29 and lastlogingmt is Not null order by lastlogingmt desc",
        },
        // ***************************************
        {
            Id: 9,
            color: "red",
            query: 'Update Student set active = 0 where Id = ',
        },
        {
            Id: 10,
            color: "red",
            query: 'Update Student set JobDescription = "" where Id = ',
        },
        {
            Id: 11,
            color: "red",
            query: 'Update Student set PostingDate = "' + stringNow + '" where Id = ',
        },
        {
            Id: 12,
            color: "red",
            query: 'Update Numbers set TotalClicks = 0 where Id = 1',
        },
        {
            Id: 13,
            color: "red",
            query: 'Update Numbers set Candidates = Candidates + 0 where Id = 1',
        },
        {
            Id: 14,
            color: "red",
            query: 'Update Student set ViewsNb = 0 where Id = ',
        },

        
        // {
        //     Id: 4,
        //     query: `Insert Into Student (col1, col2) select (col1, col2) from student where Id = `,
        // },
    ]

    const toast = useToast();

    const [data, setData] = useState([]);
    const [query, setQuery] = useState("");
    const [isLoadingJobs, setIsLoadingJobs] = useState(false);

    let bearerToken = null;
    let expiresAt = 0;

    // 🧠 This function lives in the FRONTEND
    async function getToken() {
        // If no token or expired, get a new one
        if (!bearerToken || Date.now() > expiresAt) {
            const res = await axios.get(`${ process.env.REACT_APP_URL }/getTempToken`, {
                withCredentials: true,
            });
            bearerToken = res.data.token;
            expiresAt = Date.now() + 60 * 1000; // 1 minute validity
        }
        console.log("bearerToken =", bearerToken);
        return bearerToken;
    }


    axios.defaults.withCredentials = true;
    useEffect(() => {
        setIsLoadingJobs(true);
        //const bearerToken = getToken();

        axios.post(`${process.env.REACT_APP_URL}/getQuery`, 
            { query: `Select id, jobtitle, ViewsNB, applicantsids, CompanyUsername from Student where ViewsNb  > 0 order by postingDate desc` }, 
            {
                headers: {
                    //"Authorization": `Bearer ${ bearerToken }`,
                    "Authorization": process.env.REACT_APP_TOKEN,
                    "Content-Type": "application/json"
                },
            }
        )
        .then(res => {
            if(res.data.status === "success") {
                setData(res.data.items);
            }
            else if(res.data.status === "failed") {
                toast("error", res.data.message);
            }
        })
        .catch((error) => {
            console.log("error = ", error);
            toast("error", "error while executing select query");
        })
        .finally(() => {
            setIsLoadingJobs(false);
        });
    }, [])

    const _setQuery= (val) => { 
        setQuery(val);
        const searchInput = document.getElementById("query");
        searchInput.focus();
    };

    //const executeQuery = async () => {
    const executeQuery = () => {

        axios.defaults.withCredentials = true;
        const searchInput = document.getElementById("query");
        searchInput.focus();
       
        //var encodedQuery = encodeURIComponent(query);  // Encodes characters such as ?,=,/,&,:

        if(query.trim() === "") {
            toast("error", "Please enter a query");
            return;
        }
        else if(query.toLocaleLowerCase().indexOf("select") >= 0) {
        //else if(encodedQuery.toLocaleLowerCase().indexOf("select") >= 0) {
            //console.log("inside delete", query);
            //axios.get(`${process.env.REACT_APP_URL}/getQuery/${encodedQuery}`,
            axios.post(`${process.env.REACT_APP_URL}/getQuery`, { query: query }, 
                {
                    headers: {
                        "Authorization": process.env.REACT_APP_TOKEN,
                        "Content-Type": "application/json"
                    },
                }
            )
            .then(res => {
                if(res.data.status === "success") {
                    //console.log(res.data.items);
                    toast("success", "Done");
                    setData(res.data.items);
                }
                else if(res.data.status === "failed") {
                    //console.log(res.data.message);
                    toast("error", res.data.message);
                }
            })
            .catch((error) => {
                console.log("error = ", error);
                toast("error", "error while executing select query");
            });
        }
        else {
            console.log("inside post");
            axios.post(`${process.env.REACT_APP_URL}/postQuery`, { query: query },
            //axios.post(`${process.env.REACT_APP_URL}/any_quer`, { query: query },
                {
                    headers: {
                        "Authorization": process.env.REACT_APP_TOKEN,
                        "Content-Type": "application/json"
                    },
                }
            )
            .then((res) => {
                if(res.data.status === "success") {
                    //setData([]);
                    setData(res.data.items);
                    toast("success", res.data.message);
                }
                else if(res.data.status === "failed") {
                    //console.log(res.data.message);
                    toast("error", res.data.message);
                }
            })
        }

        /*
        fetch("http://localhost:5000/runQuery", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ sql: "SELECT * FROM users WHERE name LIKE '%John%'" }),
        });
        or
        Using axios request always use POST for queries:
        GET requests encode data in the URL, which breaks with special characters.
        POST keeps it safe and clean.
        */
    }

    const nothing = (e) => {
        
    }

    const handleSubmit = (e) => {
        e.preventDefault();
    }

    return (
        <div className="mysql-query-section">
            <div className="left-side">
                <form onSubmit={ handleSubmit } className='queries-form'>
                    {
                        queriesExamples &&
                        queriesExamples.length > 0 &&
                        Array.isArray(queriesExamples) &&
                        queriesExamples.map((queryExample, index) => {
                            return (
                                <div key={index} 
                                    className='example' 
                                    style={{ color: queryExample.color }}
                                    onClick={ () => _setQuery(queryExample.query) }>
                                    { index + 1}. { queryExample.query }
                                </div>
                            )
                        })
                    }

                    <input type="text"
                            id="query"
                            className="mysql-query-input"
                            placeholder="Enter your query"
                            value={ query }
                            onChange={ (e) => _setQuery(e.target.value) }
                            name="company-name" />
                    <br/>
                    <input type="button" 
                            value="Execute Query"
                            onClick={ executeQuery }
                            className="execute-query btn-activate-job" />
                    <br/>
                    {/* <pre>
                    { 
                        data &&
                        Array.isArray(data) &&
                        data.length > 0 &&
                        JSON.stringify(data, null, "\n\r")
                    }
                    </pre> */}
                </form>
            </div>
            
            <div className="right-side"> { isLoadingJobs === true ? 'Is Loading' : '' }
                    <textarea className="mysql-query-textarea"
                        cols='50' 
                        rows='70'
                        // placeholder="Enter your query here"
                        value={ data &&
                            Array.isArray(data) &&
                            data.length > 0 ?
                            JSON.stringify(data, null, "\n") : "" }
                        onChange={ (e) => nothing(e.target.value) }
                        >
                    </textarea>
            </div>
        </div>
    );
}

export default AdminQuery;